module.exports = __webpack_public_path__ + "static/media/400176_02.a7b60d84.png";